module.exports = __webpack_public_path__ + "static/media/step-small-full-mobile.53a19e4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/step-small-full-mobile.svg
// module id = 861
// module chunks = 21